/*-------------------------------------------*\
    custom.js

    Index
    1.0 - General
    2.0 - MISC
    3.0 - Infinity Slider
    4.0 - Highlights
        4.1 - Add • Between Highlights
    5.0 - Highlights With Image
        5.1 - Add • Between Highlights With Image
    6.0 - Before And After
    7.0 - Review Carousel
    8.0 - Tablify
    9.0 - Slider Comparison
    10.0 - Product Questions
    11.0 - Sticky ATC
    12.0 - FAQ
    13.0 - Announcement Bar
\*-------------------------------------------*/

$(document).ready(function () {
  /*-------------------------------------------*\
   3.0 - Infinity Slider
\*-------------------------------------------*/
$('.slider_image').slick({
 slidesToShow: 6,
   arrows: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 3000,
  pauseOnHover: false,
  cssEase: 'linear',
           responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
 });




  
  $(".infinity-slider__slider").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    arrows: false,
    draggable: false,
    swipe: false,
    centerMode: true,
    variableWidth: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    cssEase: "linear",
    pauseOnFocus: false,
    pauseOnHover: false,
  });

  /*-------------------------------------------*\
   6.0 - Before And After
\*-------------------------------------------*/
  $(".before-and-after__slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    loop: true,
    speed: 300,
    slidesToShow: 1,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
  });

  /*-------------------------------------------*\
   7.0 - Review Carousel
\*-------------------------------------------*/
  $(".review-carousel__slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
$(".review-video").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
  /*-------------------------------------------*\
   8.0 - Tablify
\*-------------------------------------------*/
  $(".tablify__navigation li:first-child").addClass("active");
  $(".tablify__content").hide();
  $(".tablify__content:first").show();

  $(".tablify__navigation li").click(function () {
    $(".tablify__navigation li").removeClass("active");
    $(this).addClass("active");
    $(".tablify__content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  
  /*-------------------------------------------*\
   10.0 - Product Questions
\*-------------------------------------------*/
  $(".product-questions__item-question").click(function (j) {
    var dropDown = $(this)
      .closest(".product-questions__item-row")
      .find(".product-questions__item-answer-container");
    $(this)
      .closest(".product-questions__questions-box")
      .find(".product-questions__item-answer-container")
      .not(dropDown)
      .slideUp();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(".product-questions__item-question.active").removeClass("active");
      $(this).addClass("active");
    }

    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
 $(".mobile_main_counting_slider").slick({ infinite: !1, slidesToShow: 1, slidesToScroll: 1, arrows: !1, dots: !0 }),
    $("span.image_count").click(function (e) {
        $("span.image_count").removeClass("active_count"), $(this).addClass("active_count");
        var t = $(this).attr("data_index");
        $("ol.mobile_main_counting_slider").slick("slickGoTo", t);
    }),
    $("ol.mobile_main_counting_slider").on("afterChange", function (e, t, o, r) {
        $("span.image_count").removeClass("active_count"), $("span.image_count[data_index='" + o + "']").addClass("active_count");
    }),
   $(".image-with-counted-wrapp span.image_count").click(function () {
        var e = $(this).attr("data_index");
        $(".side_counting ol.desktop_main_counting li").removeClass("active_side_count"), $(".side_counting ol.desktop_main_counting li[data-main='" + e + "']").addClass("active_side_count");
    });
  /*-------------------------------------------*\
   12.0 - FAQ
\*-------------------------------------------*/
  $(".faq__tab-sections dl").hide();
  $(".faq__tab-sections dl:first").show();
  $(".faq__tabs-nav li:first").addClass("tab-active");
  $(".faq__tabs-nav a").on("click", function (event) {
    event.preventDefault();
    $(".faq__tabs-nav li").removeClass("tab-active");
    $(this).parent().addClass("tab-active");
    $(".faq__tab-sections dl").hide();
    $($(this).attr("href")).fadeIn(300).show();
  });

  $(".faq__btn").on("click", function () {
    if ($(this).hasClass("open")) {
      $(this).toggleClass("open").next().slideToggle(300);
    } else {
      $(".faq__btn.open").toggleClass("open").next().slideToggle(300);
      $(this).toggleClass("open").next().slideToggle(300);
    }
  });

  /*-------------------------------------------*\
   13.0 - Announcement Bar
\*-------------------------------------------*/
  $(".announcement-bar__slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
  });
});

/*-------------------------------------------*\
   4.0 - Highlights
\*-------------------------------------------*/
setInterval(function () {
  var next =
    $(".highlights__item-active").next().length > 0
      ? $(".highlights__item-active").next()
      : $(".highlights__item:first");
  $(".highlights__item-active").removeClass("highlights__item-active");
  next.addClass("highlights__item-active");
}, 2000);

/* ==[ 4.1 - Add • Between Highlights ]== */
var children = $(".highlights__item-container").children();
for (var i = 0; i < children.length - 1; i++) {
  children[i].insertAdjacentText("beforeend", " • ");
}

/*-------------------------------------------*\
   5.0 - Highlights With Image
\*-------------------------------------------*/
setInterval(function () {
  var next =
    $(".highlights-with-image__item-active").next().length > 0
      ? $(".highlights-with-image__item-active").next()
      : $(".highlights-with-image__item.mobile:first");
  $(".highlights-with-image__item-active").removeClass(
    "highlights-with-image__item-active"
  );
  next.addClass("highlights-with-image__item-active");
}, 2000);

/* ==[ 5.1 - Add • Between Highlights With Image ]== */
var children = $(".highlights-with-image__item-container.mobile").children();
for (var i = 0; i < children.length - 1; i++) {
  children[i].insertAdjacentText("beforeend", " • ");
}

/*-------------------------------------------*\
   11.0 - Sticky ATC
\*-------------------------------------------*/
